/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React, { Component } from "react";
import DataTable from 'react-data-table-component';
import {
  // Form,
  Input,
  Button,
  Radio,
  DatePicker,
} from "antd";
import butSearch from "../../../assets/icons/icon-but-search.png";
import Cookies from "js-cookie";
import "./custom-antd.css";
import moment from "moment";
import Api from "../../../services/ServiceApi";
import { connect } from "react-redux";
import { changeLang } from "../../../actions/langAction";
import { setDynamic } from "../../../actions/dynamicAction";
import 'moment/locale/th';
// import locale from 'antd/lib/locale/th_TH';

class FixProblemType extends Component {
  constructor(props) {
    super(props);
    this.state = {
        factUpdate: false,
        LangTranslate: [[]],
        title: "Problem Type",
        companyID: Number(Cookies.get("companyid")),
        operatorID: Number(Cookies.get("operator_id")),
        projectID: Number(Cookies.get("project_id")),
        operatorIDAdd: "",
        projectIDAdd: "",
        jobTypeIDAdd: 0,
        operator: [],
        projectData: [],
        filterProjectdata: [],
        operatorAdd: [],
        projectDataAdd: [],
        filterProjectdataAdd: [],
        jobTypeDataAdd: [],

        AddProblemTypeDisplay: "none",
        ConfirmDisplay: "none",
        dateFormat: "DD/MM/YYYY",
        EffectiveDateAdd: moment().toDate(),
        ExpiryDateAdd: moment().toDate(),
        statusAdd: 1,
        problemTypeIDAdd: "",
        problemTypeCodeAdd: "",
        problemTypeNameAdd: "",
        problemDescriptionAdd: "",
        active: ["Inactive","Active"],
        where: "",
        filterDataList: [],
        fillEffectiveDateDisplay: "none",
        resultAddNewFail: false,
        resultAddNewText: "",
        actionProblemType: "Add",
        actionProblemTypeButton: "Add",
        disableChangeValue: false,
        EffectiveDateAddFilter: moment().toDate()
    };
  }

  async componentDidMount() {
    Api.post("master_language_detail_get", {
      company_id: Cookies.get("companyid"),
      page_id: 1,
    })
      .then((response) => {
        this.setState({
          LangTranslate: JSON.parse(
            response.data.data["masteR_LANGUAGE_DETAIL"][0].file_json
          ),
          factUpdate: true,
        });
      })
      .catch((e) => {
        console.log(e);
      });

    if (
      localStorage.getItem("projectData") === null ||
      localStorage.getItem("projectData") === undefined
    ) {
      this.logoutClicked();
    } else {
      const filterProjectdata = JSON.parse(
        localStorage.getItem("projectData")
      ).filter((data) => {
        //return data.operator_id == Cookies.get("operator_id");
        return data.operator_id == this.state.operatorID;
      });
      this.setState({
        operator: JSON.parse(localStorage.getItem("operator")),
        projectData: filterProjectdata,
      });

      const filterProjectdataAdd = JSON.parse(
        localStorage.getItem("projectData")
      ).filter((data) => {
        //return data.operator_id == Cookies.get("operator_id");
        return data.operator_id == this.state.operatorIDAdd;
      });
      this.setState({
        operatorAdd: JSON.parse(localStorage.getItem("operator")),
        projectDataAdd: filterProjectdataAdd,
      });
    }
    this.loadProblemType();
  }

  loadProjectSelection = (operator_id,project_id) => {
    const filterProjectdata = JSON.parse(
      localStorage.getItem("projectData")
    ).filter((data) => {
      //return data.operator_id == Cookies.get("operator_id");
      return data.operator_id == operator_id;
    });
    this.setState({
      operatorID: operator_id,
      projectID: project_id,
      projectDataAdd: filterProjectdata,
    });
  }

  loadProjectAddSelection = (operator_id,project_id) => {
    const filterProjectdataAdd = JSON.parse(
      localStorage.getItem("projectData")
    ).filter((data) => {
      //return data.operator_id == Cookies.get("operator_id");
      return data.operator_id == operator_id;
    });
    this.setState({
      operatorIDAdd: operator_id,
      projectIDAdd: project_id,
      projectDataAdd: filterProjectdataAdd,
    });
  }

  clickEdit = (company_id, operator_id, project_id, job_type_id, problem_type_code) => {
    Api.post("master_data/job_problem_type", {
      company_id: company_id,
      operator_id: operator_id,
      project_id: project_id,
      job_type_id: job_type_id,
      where: problem_type_code,
    })
      .then((res) => {
        const { result, data } = res.data;
        if (result.code === "P") {
          data.result.map((item, index) => (

            this.setState({
              operatorIDAdd: operator_id,
              projectIDAdd: project_id,
              jobTypeIDAdd: job_type_id,
              problemTypeIDAdd: item.problem_type_id,
              problemTypeCodeAdd: item.problem_type_code,
              problemTypeNameAdd: item.problem_type_name,
              problemDescriptionAdd: item.problem_type_desc,
              statusAdd: item.is_active,
              EffectiveDateAdd: this.displayDate(item.effective_date),
              EffectiveDateAddFilter: item.effective_date,
              ExpiryDateAdd: (item.expire_date != null)? this.displayDate(item.expire_date) : "",
              actionProblemType: "Edit",
              actionProblemTypeButton: "Save",
              disableChangeValue: true
            })

          ))
          this.loadJobTypeDataAdd();
          this.onAddProblemType();
          this.loadProjectAddSelection(operator_id,project_id);
        }
      })
      .catch((e) => {
        console.log("error loading problem type", e);
      });
  };

  onSearch = () => {
    console.log('search');
    this.setState({filterDataList: []});
    this.loadProblemType();
  }

  loadProblemType = () => {
    this.setState({filterDataList:[]});
    Api.post("master_data/job_problem_type", {
      company_id: this.state.companyID,
      operator_id: this.state.operatorID,
      project_id: this.state.projectID,
      job_type_id: null,
      where: this.state.where,
    })
      .then((res) => {
        const { result, data } = res.data;
        if (result.code === "P") {
          const tmp = [];
          data.result.map((item, index) => (
          tmp.push({
            "Code": item.problem_type_code,
            "ProblemTypeName": <div title={item.problem_type_name}>{item.problem_type_name}</div>,
            "ProblemTypeDescription": <div title={item.problem_type_desc}>{item.problem_type_desc}</div>,
            "Status": <div className={"problem-type-"+this.state.active[item.is_active]}>{this.state.active[item.is_active]}</div>,
            "EffectiveDate": this.displayDate(item.effective_date),
            "ExpiredDate": this.displayDate(item.expire_date),
            "Option":<button onClick={()=> this.clickEdit(item.company_id,item.operator_id,item.project_id,item.job_type_id,item.problem_type_code)} id={"btnEdit"+index} className="text-primary">edit</button>
            })
          ));
          this.setState({ filterDataList: tmp});
        }
      })
      .catch((e) => {
        console.log("error loading problem type", e);
      });
  }

  setOperator = (event) => {
    this.setState({
      operatorID: event.target.value
    });

    const filterProjectdata = JSON.parse(
      localStorage.getItem("projectData")
    ).filter((data) => {
      return data.operator_id == event.target.value;
    });

    this.setState({
      projectID: "",
      projectData: filterProjectdata,
    });

  };
  setProjectData = (event) => {
    this.setState({
      projectID: event.target.value
    })
  };

  setOperatorAdd = (event) => {
    this.setState({
      operatorIDAdd: event.target.value
    });

    const filterProjectdataAdd = JSON.parse(
      localStorage.getItem("projectData")
    ).filter((data) => {
      return data.operator_id == event.target.value;
    });

    this.setState({
      projectIDAdd: "",
      projectDataAdd: filterProjectdataAdd,
    });

  };

  loadJobTypeDataAdd = () => {
    Api.post("V4/get_job_type", {
      company_id: this.state.companyID,
      operator_id: this.state.operatorIDAdd,
      project_id: this.state.projectIDAdd,
      pk_id: null,
      fk_id: null,
      is_active: 1,
      effective: 1,
      sql_where: null,
      UserName: Cookies.get("username"),
    })
      .then((res) => {
        this.setState({jobTypeDataAdd: res.data.data})
      })
      .catch((e) => {
        console.log("error loading job type", e);
      });
  }

  setProjectDataAdd = (event) => {
    this.setState({
      projectIDAdd: event.target.value
    })
    this.loadJobTypeDataAdd();
  };

  setJobTypeDataAdd = (event) => {
    this.setState({
      jobTypeIDAdd: event.target.value
    })
  }

  setProblemTypeCodeAdd = (event) => {
    this.setState({
      problemTypeCodeAdd: event.target.value
    })
  }

  setProblemTypeNameAdd = (event) => {
    this.setState({
      problemTypeNameAdd: event.target.value
    })
  }

  setProblemDescriptionAdd = (event) => {
    this.setState({
      problemDescriptionAdd: event.target.value
    })
  }

  setStatus = (event) => {
    this.setState({
      statusAdd: event.target.value
    })
  }

  setSearchText = (event) => {
    this.setState({
      where: event.target.value
    })
  }

  onChangeEffectiveDate = (date, dateString) =>{
    this.setState({
      EffectiveDateAdd: dateString,
      EffectiveDateAddFilter: moment(dateString,"DD/MM/YYYY")
    })
  }

  onChangeExpiryDate = (date, dateString) => {
    this.setState({
      ExpiryDateAdd: dateString
    })
  }

  onAddProblemType = () => {
    window.scrollTo(0, 0);
    if(this.state.AddProblemTypeDisplay == "none"){
      this.setState({
        AddProblemTypeDisplay: "block"
      })
    }else{
      this.setState({
        AddProblemTypeDisplay: "none"
      })
    }
  }

onCallConfirmWindow = () => {
  if(this.state.ConfirmDisplay == "none"){
    this.setState({ConfirmDisplay: "block"});
  }else{
    this.setState({ConfirmDisplay: "none", resultAddNewFail: false})
  }
}

onResetFormAddNew = () => {
  this.onCallConfirmWindow();
  this.onCloseAddNewWindow();
  this.onAddProblemType();
}

onCloseAddNewWindow = () => {
  this.setState({
    operatorIDAdd: "",
    projectIDAdd: "",
    problemTypeCodeAdd: "",
    problemTypeNameAdd: "",
    problemDescriptionAdd: "",
    statusAdd: 1,
    EffectiveDateAdd: moment().toDate(),
    EffectiveDateAddFilter: moment().toDate(),
    ExpiryDateAdd: moment().toDate(),
    AddProblemTypeDisplay: "none",
    actionProblemType: "Add",
    actionProblemTypeButton: "Add",
    disableChangeValue: false
  })
}
displayDate  = (data) => {
  if(data != null){
    const day = data.substring(0,10).split("-");
    return day[2] + "/" + day[1] + "/" + day[0];
  }
  return "-";
}
onCallConfirmWindowAndCallAddNewAgain = () => {
  this.onCallConfirmWindow();
  this.onAddProblemType();
}

ClickAction = (e) => {
  window.scrollTo(0, 0);
  const operator_id = this.state.operatorIDAdd;
  const project_id = this.state.projectIDAdd;
  e.preventDefault();
  if(this.state.EffectiveDateAdd == ""){
    this.setState({fillEffectiveDateDisplay:"block"});
  }else{
    this.setState({fillEffectiveDateDisplay:"none"});
    /** statement save data */
    (this.state.actionProblemType == "Add") ?
      Api.post("master_data/insert_job_problem_type", {
      company_id: this.state.companyID,
      operator_id: this.state.operatorIDAdd,
      project_id: this.state.projectIDAdd,
      job_type_id: this.state.jobTypeIDAdd,
      problem_type_code: this.state.problemTypeCodeAdd,
      problem_type_name: this.state.problemTypeNameAdd,
      problem_type_desc: this.state.problemDescriptionAdd,
      is_active: this.state.statusAdd,
      effective_date: moment(this.state.EffectiveDateAdd,"DD/MM/YYYY").format("YYYY-MM-DD"),
      expire_date: (this.state.ExpiryDateAdd) != ''? moment(this.state.ExpiryDateAdd,"DD/MM/YYYY").format("YYYY-MM-DD"):null,
      create_by: Cookies.get("userId")
    })
      .then((res) => {
        console.log('Action: Add');
        const { result } = res.data;
        if (result.code === "P") {
          this.setState({resultAddNewFail: false})

          this.onCloseAddNewWindow();
        }else{
          this.setState({AddProblemTypeDisplay : "none",resultAddNewFail: true})
        }
        if(result.showText == "Success"){
          this.setState({resultAddNewText:"เพิ่มข้อมูลเสร็จสิ้น"});
        }else{
          this.setState({resultAddNewText:result.showText});
        }
        /** confirm */
        this.onCallConfirmWindow();
        this.loadProjectSelection(operator_id, project_id);
        this.loadProblemType();

      })
      .catch((e) => {
        console.log("error add new problem type", e);
      })
    : this.editData(e)

    /** statement save data */
  }
  e.stopPropagation();
}

editData = (e) => {
  console.log('Action: Edit');
  window.scrollTo(0, 0);
  e.preventDefault();
  if(this.state.EffectiveDateAdd == ""){
    this.setState({fillEffectiveDateDisplay:"block"});
  }else{
    this.setState({fillEffectiveDateDisplay:"none"});
    /** statement save data */
    Api.post("master_data/update_job_problem_type", {
      company_id: this.state.companyID,
      operator_id: this.state.operatorIDAdd,
      project_id: this.state.projectIDAdd,
      problem_type_id: this.state.problemTypeIDAdd,
      job_type_id: this.state.jobTypeIDAdd,
      problem_type_code: this.state.problemTypeCodeAdd,
      problem_type_name: this.state.problemTypeNameAdd,
      problem_type_desc: this.state.problemDescriptionAdd,
      is_active: this.state.statusAdd,
      effective_date: moment(this.state.EffectiveDateAdd,"DD/MM/YYYY").format("YYYY-MM-DD"),
      expire_date: (this.state.ExpiryDateAdd) != ''? moment(this.state.ExpiryDateAdd,"DD/MM/YYYY").format("YYYY-MM-DD"):null,
      update_by: Cookies.get("userId")
    })
      .then((res) => {
        const { result } = res.data;
        if (result.code === "P") {
          this.setState({resultAddNewFail: false})
          this.onCloseAddNewWindow();
        }else{
          this.setState({AddProblemTypeDisplay : "none",resultAddNewFail: true})
        }
        if(result.showText == "Success"){
          this.setState({resultAddNewText:"แก้ไขข้อมูลเสร็จสิ้น"});
        }else{
          this.setState({resultAddNewText:result.showText});
        }
        /** confirm */
        this.onCallConfirmWindow();
        this.loadProblemType();

      })
      .catch((e) => {
        console.log("error editing problem type", e);
      })
  }
}

render() {
  const locale = Cookies.get("locale");
  const columns =  [

    {
      name: (this.state.factUpdate)? this.state.LangTranslate[locale]["Code"] : `Code`,
      selector: 'Code',
      sortable: true,
    },
    {
      name: (this.state.factUpdate)? this.state.LangTranslate[locale]["Name"] : 'Name',
      selector: 'ProblemTypeName',
      sortable: true,
    },
    {
      name: (this.state.factUpdate)? this.state.LangTranslate[locale]["Description"] : 'Description',
      selector: 'ProblemTypeDescription',
    },
    {
      name: (this.state.factUpdate)? this.state.LangTranslate[locale]["status"] : 'Status',
      selector: 'Status',
    },
    {
      name: (this.state.factUpdate)? this.state.LangTranslate[locale]["EffectiveDate"] : 'Effective Date',
      selector: 'EffectiveDate',
      sortable: true,
    },
    {
      name: (this.state.factUpdate)? this.state.LangTranslate[locale]["ExpiredDate"] : 'Expired Date',
      selector: 'ExpiredDate',
      sortable: true,
    },
    {
      name: (this.state.factUpdate)? this.state.LangTranslate[locale]["Action"] :'Action',
      selector: 'Option',
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      style: 'cursor:pointer'
    },
  ];

        return (
            <div>
                <span className="font-mont-r fs-12">Basic Data</span>
                <h3 className="font-mont-sb fs-18 c-blue">{this.state.title}</h3>
                <div className="w-100 box-search m-0">
                  <div className="row">
                    <div>
                      <div className="title-search">Operator</div>
                      <div>
                        <select
                        placeholder="Please select Operator"
                        className="dropdrowtype input-text-add-problem-type form-select"
                        onChange={this.setOperator}
                        value={this.state.operatorID}
                      >
                        <option value="" className="please-select">PLEASE SELECT OPERATOR</option>
                        {this.state.operator.map((item, index) => (
                          <option
                            value={item.operator_id}
                            key={`layoutoption_${index}`}
                          >
                            {item.operator_name}
                          </option>
                        ))}
                        </select>
                      </div>
                    </div>
                    <div className="box-search">
                      <div className="title-search">Project</div>
                      <div className="row">
                          <div>
                          <select
                              placeholder="Please select Project"
                              className="dropdrowtype input-text-add-problem-type form-select"
                              onChange={this.setProjectData}
                              value={this.state.projectID}
                            >
                              <option value="" className="please-select">PLEASE SELECT PROJECT</option>
                            {this.state.projectData.map((item, index) => (
                              <option value={item.project_id} key={`layout_b_${index}`}>
                                {item.project_name}
                              </option>
                            ))}
                          </select>
                          </div>
                          <div style={{verticalAlign:"text-top"}}>
                            <div className="box-search">
                              <Input
                                onChange={this.setSearchText}
                                placeholder="Search"
                                style={{ width: 200 }}
                              />
                              <img type="button" src={butSearch} onClick={this.onSearch} className="but-search"/>
                            </div><br></br>
                            <div className="box-search txt-comment">Ex. 2021-06-18 รูปแบบการหาแบบวันที่</div>
                          </div>
                      </div>
                    </div>
                    <div className="box-but-add-problem-type">
                      <div>&nbsp;</div>
                      <div><button className="but-add-problem-type" onClick={this.onAddProblemType}>Add {this.state.title}</button></div>
                    </div>
                  </div>
                </div>

                <div className="box-content">
                    {/** load data */}
                    <DataTable
                      columns={columns}
                      data={this.state.filterDataList}
                      pagination
                      highlightOnHover
                    />
                </div>

                <div id="AddProblemTypeWindow" className="add-new-window" style={{
                          position: 'absolute', top: '20%',
                          left: '50%',
                          marginLeft: '-260px',
                          display: this.state.AddProblemTypeDisplay
                      }}>
                  <form className="needs-validation" onSubmit={this.ClickAction}>
                  <div>
                    <div className="header-add-problem-type-window">{this.state.actionProblemType} {this.state.title}</div>
                    {/* row1 */}
                    <div className="row row-add">
                      <div className="col-sm-4 m-0 p-0">
                        <div className="title-add"><i className="data-important">*</i>Operator</div>
                        <div>
                            <select
                            id="OperatorAdd"
                            placeholder="Please select Operator"
                            className="dropdrowtype select-problem-type form-select"
                            onChange={this.setOperatorAdd}
                            value={this.state.operatorIDAdd}
                            disabled={(this.state.disableChangeValue)? "disabled":false}
                            required
                          >
                            <option value="" className="please-select">PLEASE SELECT OPERATOR</option>
                            {this.state.operatorAdd.map((item, index) => (
                              <option
                                value={item.operator_id}
                                key={`layoutoption_${index}`}
                              >
                                {item.operator_name}
                              </option>
                            ))}
                            </select>
                        </div>
                      </div>
                      <div className="col-sm-4 m-0 p-0">
                        <div className="title-add"><i className="data-important">*</i>Project</div>
                        <div>
                            <select
                                  id="ProjectAdd"
                                  placeholder="Please select Project"
                                  className="dropdrowtype select-problem-type form-select"
                                  onChange={this.setProjectDataAdd}
                                  value={this.state.projectIDAdd}
                                  disabled={(this.state.disableChangeValue)? "disabled":false}
                                  required
                                >
                                <option value="" className="please-select">PLEASE SELECT PROJECT</option>
                                {this.state.projectDataAdd.map((item, index) => (
                                  <option value={item.project_id} key={`layout_b_${index}`}>
                                    {item.project_name}
                                  </option>
                                ))}
                              </select>
                        </div>
                      </div>
                      <div className="col-sm-4 m-0 p-0">
                      <div className="title-add"><i className="data-important">*</i>Job Type</div>
                        <div>
                            <select
                                  id="JobTypeAdd"
                                  placeholder="Please select Job Type"
                                  className="dropdrowtype select-problem-type form-select"
                                  onChange={this.setJobTypeDataAdd}
                                  value={this.state.jobTypeIDAdd}
                                  required
                                >
                                <option value="" className="please-select">PLEASE SELECT Job Type</option>
                                {this.state.jobTypeDataAdd.map((item, index) => (
                                  <option value={item.job_type_id} key={`layout_b_${index}`}>
                                    {item.job_type_name}
                                  </option>
                                ))}
                              </select>
                        </div>
                      </div>
                    </div>

                    {/* row2 */}
                    <div className="row row-add">
                      <div className="col-sm-6 m-0 p-0">
                      <div className="title-add"><i className="data-important">*</i>{(this.state.factUpdate)? this.state.LangTranslate[locale]["ProblemTypeCode"] : `Problem Type Code`}</div>
                        <div>
                          <input id="problemTypeCodeAdd" onChange={this.setProblemTypeCodeAdd} value={this.state.problemTypeCodeAdd} className="input-text-add-problem-type" required></input>
                        </div>
                      </div>
                      <div className="col-sm-6 m-0 p-0 pl-3">
                      <div className="title-add"><i className="data-important">*</i>{(this.state.factUpdate)? this.state.LangTranslate[locale]["ProblemTypeName"] : `Problem Type Name`}</div>
                        <div><input value={this.state.problemTypeNameAdd} onChange={this.setProblemTypeNameAdd} className="input-text-add-problem-type" required></input>
                        </div>
                      </div>
                    </div>
                    {/* row3 */}
                    <div className="row row-add">
                      <div className="col-sm-12 m-0 p-0">
                        <div className="title-add"><i className="data-important">*</i>{(this.state.factUpdate)? this.state.LangTranslate[locale]["ProblemTypeDescription"] : `Problem Type Description`}</div>
                      </div>
                      <div className="col-sm-12 p-0">
                        <textarea value={this.state.problemDescriptionAdd} className="" onChange={this.setProblemDescriptionAdd} rows={2} required/>
                      </div>
                    </div>
                    {/* row4 */}
                    <div className="row row-add">
                      <div className="col-sm-12 m-0 p-0">
                        <div className="title-add"><i className="data-important">*</i>{(this.state.factUpdate)? this.state.LangTranslate[locale]["status"] : `Status`}</div>
                      </div>
                      <div className="col-sm-12 p-0">
                      <Radio.Group 
                        id="statusAdd"
                        name="statusAdd" 
                        defaultValue={this.state.statusAdd}
                        onChange={this.setStatus}
                      >
                        <Radio value={1}>Active</Radio>
                        <Radio value={0}>Inactive</Radio>
                      </Radio.Group>
                      </div>
                    </div>
                    {/* row5 */}
                    <div className="row row-add">
                      <div className="col-sm-6 m-0 p-0">
                        <div className="title-add"><i className="data-important">*</i>{(this.state.factUpdate)? this.state.LangTranslate[locale]["EffectiveDate"] : 'Effective Date'}</div>
                        <div><DatePicker style={{padding: 8}} onChange={this.onChangeEffectiveDate} value={(this.state.EffectiveDateAdd != '')? moment(this.state.EffectiveDateAdd, this.state.dateFormat):""} format={this.state.dateFormat}/>
                        <div style={{display: this.state.fillEffectiveDateDisplay, position: "absolute",color:"#FF0000"}}>Please fill effective date</div>
                        </div>
                      </div>
                      <div className="col-sm-6 m-0 p-0 pl-3">
                        <div className="title-add">{(this.state.factUpdate)? this.state.LangTranslate[locale]["ExpiredDate"] : 'Expired Date'}</div>
                        <div>
                          <DatePicker style={{padding: 8}} onChange={this.onChangeExpiryDate}  value={(this.state.ExpiryDateAdd != '')? moment(this.state.ExpiryDateAdd, this.state.dateFormat):""} format={this.state.dateFormat} disabledDate={d => !d || d.isAfter(moment().add(100,"years")) || d.isSameOrBefore(this.state.EffectiveDateAddFilter)} /></div>
                      </div>
                    </div>
                    {/* row5 */}
                    <div className="row row-add">
                      <div className="col-sm-12 m-0 p-0 pt-3 text-center">
                        <Button onClick={this.onCloseAddNewWindow}>&nbsp;&nbsp;Cancel&nbsp;&nbsp;</Button>&nbsp;<button type="submit"  className="btn btn-primary-active" >&nbsp;&nbsp;&nbsp;{this.state.actionProblemTypeButton}&nbsp;&nbsp;&nbsp;</button>
                      </div>
                    </div>

                  </div>
                </form>
                </div>

                <div id="ConfirmWindow" className="confirm-window" style={{
                          position: 'absolute', left: '50%', top: '20%',
                          transform: 'translate(-50%, -20%)',
                          display: this.state.ConfirmDisplay
                      }}>
                  <div className="row">
                    <div className="col-sm-12 m-0 p-3 text-center txt-confirm">
                      {this.state.resultAddNewText}
                    </div>
                  </div>
                  <div className="row row-add">
                    <div className="col-sm-12 m-0 p-0 text-center">
                      {
                        (this.state.actionProblemType == "Add")?
                          ((this.state.resultAddNewFail == true)? <Button type="primary" onClick={this.onCallConfirmWindowAndCallAddNewAgain}>&nbsp;&nbsp;ปิด&nbsp;&nbsp;</Button> : <Button onClick={this.onResetFormAddNew}>&nbsp;&nbsp;&nbsp;เพิ่มอีกครั้ง&nbsp;&nbsp;&nbsp;</Button>):null
                      }&nbsp;&nbsp;
                      {
                        (this.state.resultAddNewFail == false)? <Button type="primary" onClick={this.onCallConfirmWindow}>&nbsp;&nbsp;ปิด&nbsp;&nbsp;</Button>:null
                      }
                    </div>
                  </div>
                </div>
            </div>
        );
    }
}
const mapStateToProps = (state) => ({
  lang: state.lang,
  dynamicReducer: state.dynamicReducer,
});
const mapDispacthToProps = (dispatch) => {
  return {
    changeLang: (data) => dispatch(changeLang(data)),
    setDynamic: (data, visible) => dispatch(setDynamic(data, visible)),
  };
};
export default connect(mapStateToProps, mapDispacthToProps)(FixProblemType);

